export default __webpack_public_path__ + "static/media/notification.2f0c417b.svg";